/* Zyvera — JS propio. Vanilla, sin librerias.
   Una funcion init por componente; cada una sale sola si su elemento no existe,
   asi el mismo archivo sirve en todas las paginas. */

(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- reveals al hacer scroll ------------------------------------------ */
  var io = null;
  function initReveals(raiz) {
    var els = (raiz || document).querySelectorAll('.zy-reveal:not(.zy-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window) || window.Shopify && Shopify.designMode) {
      els.forEach(function (el) { el.classList.add('zy-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('zy-visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* --- hero slider -------------------------------------------------------- */
  function initHeros(raiz) {
    (raiz || document).querySelectorAll('[data-zy-hero]').forEach(function (hero) {
      if (hero.dataset.zyListo) return;
      hero.dataset.zyListo = '1';
      var track = hero.querySelector('.zy-hero__track');
      var slides = hero.querySelectorAll('.zy-slide');
      var dots = hero.querySelectorAll('.zy-hero__dot');
      if (!track || slides.length < 2) return;

      var actual = 0;
      function ir(i) {
        actual = (i + slides.length) % slides.length;
        track.scrollTo({ left: actual * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }
      function marcar() {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        actual = Math.max(0, Math.min(slides.length - 1, i));
        dots.forEach(function (d, j) {
          d.classList.toggle('is-activo', j === actual);
          d.setAttribute('aria-current', j === actual ? 'true' : 'false');
        });
      }
      var t = null;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(marcar, 60); }, { passive: true });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { ir(j); reiniciar(); }); });
      var prev = hero.querySelector('.zy-hero__flecha--prev');
      var next = hero.querySelector('.zy-hero__flecha--next');
      if (prev) prev.addEventListener('click', function () { ir(actual - 1); reiniciar(); });
      if (next) next.addEventListener('click', function () { ir(actual + 1); reiniciar(); });

      // autoplay: se pausa con el dedo o el mouse encima, y en el editor
      var ms = parseInt(hero.dataset.zyAuto || '0', 10) * 1000;
      var timer = null;
      function arrancar() {
        if (!ms || reduce || (window.Shopify && Shopify.designMode)) return;
        parar();
        timer = setInterval(function () { ir(actual + 1); }, ms);
      }
      function parar() { if (timer) clearInterval(timer); timer = null; }
      function reiniciar() { parar(); arrancar(); }
      hero.addEventListener('mouseenter', parar);
      hero.addEventListener('mouseleave', arrancar);
      hero.addEventListener('touchstart', parar, { passive: true });
      hero.addEventListener('touchend', function () { setTimeout(arrancar, 4000); }, { passive: true });
      document.addEventListener('visibilitychange', function () { document.hidden ? parar() : arrancar(); });
      marcar();
      arrancar();
    });
  }

  /* --- barra fija de compra --------------------------------------------- */
  function initSticky() {
    var barra = document.querySelector('.zy-sticky');
    if (!barra || barra.dataset.zyListo) return;
    barra.dataset.zyListo = '1';
    // referencia: el boton de compra real de la ficha
    var ancla = document.querySelector('.product-form__submit') || document.querySelector('form[action*="/cart/add"] [name="add"]');
    if (!ancla) return;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          var ver = !e.isIntersecting && e.boundingClientRect.top < 0;
          barra.classList.toggle('is-visible', ver);
          document.body.classList.toggle('zy-sticky-on', ver);
        });
      }, { threshold: 0 }).observe(ancla);
    }

    var btn = barra.querySelector('[data-zy-sticky-comprar]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        // el boton real maneja variantes, cantidad y el carrito lateral del tema
        ancla.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        setTimeout(function () { if (!ancla.disabled) ancla.click(); }, reduce ? 0 : 450);
      });
    }

    // precio de la barra al dia cuando cambia la variante
    var precio = barra.querySelector('.zy-sticky__precio');
    var fuente = document.querySelector('.product__info-container .price');
    if (precio && fuente && 'MutationObserver' in window) {
      // Dawn reemplaza el bloque de precio entero: se vuelve a buscar cada vez
      var copiar = function () {
        fuente = document.querySelector('.product__info-container .price');
        if (!fuente) return;
        var venta = fuente.querySelector('.price__sale .price-item--sale');
        var normal = fuente.querySelector('.price__regular .price-item--regular');
        var tachado = fuente.querySelector('.price__sale s.price-item--regular');
        var enOferta = fuente.closest('.price--on-sale') || fuente.classList.contains('price--on-sale');
        var p = enOferta && venta ? venta.textContent.trim() : (normal ? normal.textContent.trim() : '');
        if (!p) return;
        precio.innerHTML = (enOferta && tachado ? '<s>' + tachado.textContent.trim() + '</s>' : '') + p;
      };
      new MutationObserver(copiar).observe(fuente.parentElement, { childList: true, subtree: true });
    }
  }

  /* --- paginas legales: indice + tablas con scroll ------------------------ */
  function initLegal() {
    var cuerpo = document.querySelector('[data-zy-indice-origen]');
    if (!cuerpo) return;

    // cada tabla en su propia caja con scroll: en movil una tabla ancha
    // haria scrollear la pagina entera hacia los lados
    cuerpo.querySelectorAll('table').forEach(function (tabla) {
      if (tabla.parentElement.classList.contains('zy-tabla')) return;
      var caja = document.createElement('div');
      caja.className = 'zy-tabla';
      tabla.parentNode.insertBefore(caja, tabla);
      caja.appendChild(tabla);
    });

    var nav = document.querySelector('[data-zy-indice]');
    if (!nav) return;
    var lista = nav.querySelector('ul');
    var titulos = cuerpo.querySelectorAll('h2');
    if (!lista || titulos.length < 3) {
      // con 1 o 2 secciones el indice estorba; se quita tambien la clase de
      // dos columnas o el texto queda aplastado en la columna del indice
      var columnas = nav.parentElement;
      nav.remove();
      if (columnas) columnas.classList.remove('zy-legal__columnas--indice');
      return;
    }
    if (lista.children.length) return; // ya armado (recarga del editor)

    titulos.forEach(function (h, i) {
      if (!h.id) {
        h.id = 'sec-' + (i + 1) + '-' + h.textContent.toLowerCase()
          .normalize('NFD').replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '').slice(0, 40);
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      lista.appendChild(li);
    });
  }

  /* --- arranque ---------------------------------------------------------- */
  function init(raiz) {
    initReveals(raiz);
    initHeros(raiz);
    initSticky();
    initLegal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // el editor de Shopify recarga secciones sueltas sin recargar la pagina
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('.zy-slide');
    var track = slide && slide.parentElement;
    if (track) track.scrollTo({ left: slide.offsetLeft });
  });
})();
